import React, { useId } from "react";
import { useI18n } from "@/context/I18nContext";

function XLetter({ h, gradA, gradB }) {
  const w = Math.round((h * 30) / 48);
  const sw = Math.max(4, Math.round(h / 6.5));
  return (
    <svg width={w} height={h} viewBox="0 0 30 48" fill="none" xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true" style={{ display: "block" }}>
      <line x1="5" y1="11" x2="25" y2="41" stroke={`url(#${gradA})`} strokeWidth={sw} strokeLinecap="round" />
      <line x1="25" y1="11" x2="5" y2="41" stroke={`url(#${gradB})`} strokeWidth={sw} strokeLinecap="round" />
    </svg>
  );
}

export function Logo({ light = false, size = "md" }) {
  const { t } = useI18n();
  const a = useId();
  const b = useId();
  const c = useId();
  const d = useId();
  const cfg = {
    sm: { xh: 18, brand: "text-lg", sub: "text-[8px]" },
    md: { xh: 24, brand: "text-2xl", sub: "text-[9px]" },
    lg: { xh: 42, brand: "text-4xl sm:text-5xl", sub: "text-[11px] sm:text-xs" },
  }[size] || { xh: 24, brand: "text-2xl", sub: "text-[9px]" };

  // "Re" and "pons" are white; the two "xx" are blue (nexxaris style).
  const word = `font-heading font-extrabold tracking-tight ${cfg.brand} text-white`;

  return (
    <div className="flex flex-col leading-none" data-testid="brand-logo" aria-label="Rexxpons">
      <svg width="0" height="0" className="absolute" aria-hidden="true">
        <defs>
          <linearGradient id={a} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#2563EB" /><stop offset="100%" stopColor="#3B82F6" />
          </linearGradient>
          <linearGradient id={b} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#3B82F6" /><stop offset="100%" stopColor="#60A5FA" />
          </linearGradient>
          <linearGradient id={c} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#3B82F6" /><stop offset="100%" stopColor="#60A5FA" />
          </linearGradient>
          <linearGradient id={d} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#2563EB" /><stop offset="100%" stopColor="#3B82F6" />
          </linearGradient>
        </defs>
      </svg>
      <div className="flex items-end" role="img" aria-label="Rexxpons">
        <span className={word}>Re</span>
        <span className="flex items-center" style={{ margin: "0 1px" }}>
          <XLetter h={cfg.xh} gradA={a} gradB={b} />
          <XLetter h={cfg.xh} gradA={c} gradB={d} />
        </span>
        <span className={word}>pons</span>
      </div>
      <span className={`font-heading font-semibold tracking-[0.18em] uppercase mt-1 whitespace-nowrap ${cfg.sub} text-blue-400`}>
        {t("brand_sub")}
      </span>
    </div>
  );
}
